import React from "react";

import LinkButton from "../components/buttons/LinkButton";
import PaymentForm from "../components/forms/PaymentForm";

function Payment() {
  return (
    <section>
      <PaymentForm></PaymentForm>
    </section>
  );
}

export default Payment;
